import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import ContentfulBlockMedia from "./ContentfulBlockMedia/ContentfulBlockMedia"
import Carousel from "../../atomic/molecules/Carousel"
import { COLORS } from "../../../theme/styles/globals"

export default class ContentfulBlockMediaAndCarousel extends React.Component {
  render() {
    const { mode, mediaBlock, gallery } = this.props

    return (
      <Container mode={mode}>
        <Image mode={mode}>
          <ContentfulBlockMedia mode={mode} {...mediaBlock} />
        </Image>
        <CarouselWrap>
          <Carousel mode={mode}>
            {gallery.map((media, i) => (
              <ContentfulBlockMedia key={i} mode={mode} {...media} />
            ))}
          </Carousel>
        </CarouselWrap>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${up("md")} {
    width: auto;
    height: 100vh;
    flex-direction: column;
    padding-left: 75px;
    padding-right: 75px;
  }
`

const CarouselWrap = styled.div`
  padding-top: 60px;

  ${up("md")} {
    display: none;
  }
`

const Image = styled.div`
  width: 100%;
  height: 100%;
  display: none;
  position: relative;

  ${up("md")} {
    display: flex;
  }
`
